import { useCallback, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { useQuery } from 'data-fetching-client';
import { GET_CSS_VARS } from 'ContentData/api/GlobalStyles';
import { useGetQuery } from '../../__generated__/chirp/com/hubspot/global/styles/rpc/GlobalStylesRpc.hooks';
import { prependGoogleFontUrls } from '../utils/globalStyles';
export const useFetchCssVars = (globalStyles = {}, options) => {
  const {
    data: globalStylesData,
    loading,
    error
  } = useGetQuery({
    skip: Boolean(globalStyles === null || globalStyles === void 0 ? void 0 : globalStyles.id)
  });
  const globalStylesId = (globalStyles === null || globalStyles === void 0 ? void 0 : globalStyles.id) || (globalStylesData === null || globalStylesData === void 0 ? void 0 : globalStylesData.id);
  const {
    isOutsidePreviewIframe,
    bufferTheme = false
  } = options || {};
  const {
    data,
    loading: cssVarsLoading,
    error: cssVarsError,
    refetch
  } = useQuery(GET_CSS_VARS, {
    variables: {
      globalStyles: Object.assign({}, globalStyles, {
        id: globalStylesId
      }),
      bufferTheme
    },
    skip: !globalStylesId
  });
  const cssVarsData = data === null || data === void 0 ? void 0 : data.cssVars;
  const previewDomain = useSelector(state => {
    var _state$previewInfo$pr, _state$previewInfo;
    return (_state$previewInfo$pr = state === null || state === void 0 || (_state$previewInfo = state.previewInfo) === null || _state$previewInfo === void 0 ? void 0 : _state$previewInfo.previewDomain) !== null && _state$previewInfo$pr !== void 0 ? _state$previewInfo$pr : '';
  });
  const transformCssVarsData = useCallback(rawCssVarsData => {
    if (!rawCssVarsData) return undefined;
    const fontStylesList = rawCssVarsData.fontStyles;
    const transformedFontStyles = fontStylesList && previewDomain && isOutsidePreviewIframe ? prependGoogleFontUrls(fontStylesList, previewDomain) : fontStylesList;
    return Object.assign({}, rawCssVarsData, {
      fontStyles: transformedFontStyles
    });
  }, [previewDomain, isOutsidePreviewIframe]);
  const transformedData = useMemo(() => transformCssVarsData(cssVarsData), [cssVarsData, transformCssVarsData]);
  const refetchAndTransform = useCallback(async () => {
    var _result$data;
    const result = await refetch();
    return {
      data: transformCssVarsData((_result$data = result.data) === null || _result$data === void 0 ? void 0 : _result$data.cssVars)
    };
  }, [refetch, transformCssVarsData]);
  return useMemo(() => {
    return {
      data: transformedData,
      loading: loading || cssVarsLoading,
      error: error || cssVarsError,
      refetch: refetchAndTransform
    };
  }, [loading, error, transformedData, cssVarsLoading, cssVarsError, refetchAndTransform]);
};